import imageProduct1 from './assets/images/Strawberry.jpg'
import imageProduct2 from './assets/images/avocado.jpg'
import imageProduct3 from './assets/images/bread.jpg'
import imageProduct4 from './assets/images/eggs.jpg'
import imageProduct5 from './assets/images/lemon.jpg'
import imageProduct6 from './assets/images/oranges.jpg'
import imageProduct7 from './assets/images/popcorn.jpg'
import imageProduct8 from './assets/images/pease.jpg'


export const Products = [
    {
        id: 1,
        name: 'Fresh Strawberry',
        price: 299,
        image: imageProduct1, 
        description: 'Fresh and tasty Strawberries available',
        slug: 'fresh-strawberry'
    },
    {
        id: 2,
        name: 'Fresh  Avocado',
        price: 399,
        image: imageProduct2, 
        description: 'Fresh and tasty Avocado available',
        slug: 'fresh-avocado'
    },
    {
        id: 3,
        name: 'Sour-Dough Bread',
        price: 299,
        image: imageProduct3, 
        description: 'Fresh and tasty Sour-Dough Bread available',
        slug: 'fresh-Sour-Dough Bread'
    },
    {
        id: 4,
        name: 'Fresh Eggs',
        price: 120,
        image: imageProduct4, 
        description: 'Fresh Eggs available',
        slug: 'fresh-eggs'
    },
    {
        id: 5,
        name: 'Fresh Lemon',
        price: 20,
        image: imageProduct5, 
        description: 'Fresh Lemon available',
        slug: 'fresh-lemon'
    },
    {
        id: 6,
        name: 'Fresh Oranges',
        price: 150,
        image: imageProduct6, 
        description: 'Fresh and tasty Oranges available',
        slug: 'fresh-oranges'
    },
    {
        id: 7,
        name: 'Fresh Popcorn',
        price: 299,
        image: imageProduct7, 
        description: 'Fresh and tasty  Popcorn available',
        slug: 'fresh-popcorn'
    },
    {
        id: 8,
        name: 'Fresh Peas',
        price: 105,
        image: imageProduct8, 
        description: 'Fresh and tasty Peas available',
        slug: 'fresh-Peas'
    }

];